import React from 'react';
import PropTypes from 'prop-types';
import values from 'lodash.values';

import Page from 'components/Page';
import Button, {ModalXButton} from 'components/Button';
import Footer from 'components/Footer';
import Spinner from 'components/Spinner';

import {bigsum, numberWithCommas, toMoney} from 'utils';

import './style.css';

/* eslint-disable max-len */
export class DealFinalizedConfirmation extends React.PureComponent {
  constructor() {
    super();
    this.addsUp = this.addsUp.bind(this);
    this.total = this.total.bind(this);
  }
  addsUp() {
    return this.total().eq(this.dealAllocation());
  }
  total() {
    const {allocations} = this.props;
    return bigsum(values(allocations));
  }
  dealAllocation() {
    const {deal} = this.props;
    return bigsum([deal.metrics.allocation, deal.metrics.flatFees]);
  }
  renderError() {
    const total = this.total();
    const deal = this.dealAllocation();
    if(total.lt(deal)) {
      const diff = deal.minus(total);
      return (
        <p styleName="error">
          You can't close this deal yet because it's underscribed by $${toMoney(diff)}
        </p>
      );
    } else if(total.gt(deal)) {
      const diff = total.minus(deal);
      return (
        <p styleName="error">
          You can't close this deal yet because it's overscribed by $${toMoney(diff)}
        </p>
      );
    }
    return '';
  }
  render() {
    const {sending, cancel, submit} = this.props;
    if (sending) {
      return (
        <Page>
          <Spinner />
        </Page>
      );
    }

    return (
      <Page>
        <header styleName="header toplevel">
          <h2 styleName="h2">What happens now?</h2>
          <ModalXButton onClick={cancel} data-test="finalized_cancel" />
        </header>
        <section styleName="content">
          <p>
            Once you’ve allocated who&#39;s investing how much, you can close the deal.
          </p>
          <p>When you move onto the next phase:</p>
          <ul>
            <li>You <strong>won’t be able to change</strong> who&#39;s investing or how much</li>
            <li>Investors will be sent <strong>contracts to sign</strong> and <strong>payment instructions</strong></li>
          </ul>
          {this.renderError()}
        </section>
        <Footer styleName="toplevel">
          <Button onClick={submit} disabled={!this.addsUp()} data-test="finalized_submit">
            Close Deal
          </Button>
        </Footer>
      </Page>
    );
  }

}

/* eslint-enable max-len */

DealFinalizedConfirmation.propTypes = {
  submit: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  sending: PropTypes.bool.isRequired,
  allocations: PropTypes.object.isRequired,
  deal: PropTypes.shape({
    metrics: PropTypes.shape({
      allocation: PropTypes.number.isRequired,
      flatFees: PropTypes.number.isRequired
    }).isRequired,
  }).isRequired,
};

export default DealFinalizedConfirmation;



// WEBPACK FOOTER //
// ./web/flows/deal/status_transitions/components/DealFinalizedConfirmation/component.js